import React, { useEffect, useState, useRef } from "react";

const CircleRow = ({selectedIndex, onSlideChange}) => {
  // const circles = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; // Array to iterate over and create circles
  // const [currentIndex, setCurrentIndex] = useState(0);
  const [circles, setCircles] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
  return (
    <div className="circle-row">
      {circles.map((circle, index) => (
        <div key={index} className={`circle ${selectedIndex === index ? 'active' : ''}`} onClick={() => {onSlideChange(index)
            
        }}></div>
      ))}
    </div>
  );
};

export default CircleRow;
